import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';

import StepTab from 'components/new_ui/Tabs/StepTab';
import Head from './Head';
import Form from './Form';
import Footer from './Footer';
import CoachItem from './CoachItem';

export default function Index() {
  const [coaches, setCoaches] = useState(JSON.parse(localStorage.getItem('managerManualCreateCoaches') || '[]'));

  const addCoach = (coach) => {
    if (coaches.find((item) => item.email === coach.email)) {
      return false;
    }
    setCoaches((prev) => [...prev, coach]);
    return true;
  };

  const removeCoach = (coach) => {
    setCoaches((prev) => prev.filter((item) => item.email !== coach.email));
  };

  const removeCoachesAfterImport = (data) => {
    let newCoaches = [...coaches];

    const isError = data.some((item) => item.status === 'error');

    data.forEach((coach) => {
      if (coach.status === 'ok') {
        if (!isError) {
          newCoaches = newCoaches.filter((item) => item.email !== coach.email && item.email !== coach.raw_email);
        }
      } else {
        const record = newCoaches.find((item) => item.email === coach.email || item.email === coach.raw_email);
        if (record) {
          record.error = coach.messages.join(',');
        }
      }
    });
    if (isError) {
      newCoaches.sort((a) => {
        if (a.error) {
          return -1;
        }
        return 0;
      });
    }
    setCoaches(newCoaches);
    return newCoaches.length === 0;
  };

  useEffect(() => {
    localStorage.setItem('managerManualCreateCoaches', JSON.stringify(coaches || []));
  }, [coaches]);

  return (
    <>
      <StepTab total={2} current={1} />

      <div className="content">
        <Head />

        <section>
          <Row>
            <Col md={6}>
              <h3>Form</h3>

              <Form addCoach={addCoach} />
            </Col>

            <Col md={6} className="mt-4 mt-md-0">
              <h3>Coach List</h3>

              {coaches.length === 0 && (
                <div className="card border-light bg-light text-dark text-center">
                  <div className="card-body">
                    <p className="card-text my-5">Your coach list will start here.</p>
                  </div>
                </div>
              )}

              {coaches.length > 0 && (
                <div className="pe-2" style={{ height: '450px', overflowY: 'auto' }}>
                  {coaches.map((coach) => (
                    <CoachItem
                      key={coach.email + coach.error}
                      coach={coach}
                      removeCoach={removeCoach}
                    />
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </section>

        <Footer coaches={coaches} removeCoachesAfterImport={removeCoachesAfterImport} />

      </div>
    </>
  );
}
